import { DocumentCode } from './types'

export const DOCUMENT_WARNING_KEYS: DocumentCode[] = [
  'acceptableUsePolicy',
  'amlPolicy',
  'proofOfAddress',
  'proofOfBusinessActivity',
  'registerOfDirectors',
  'shareholderCertificate',
  'shareholderStructureChart',
]

export const SIMPLE_TOOLTIP_KEYS: DocumentCode[] = [
  'acceptableUsePolicy',
  'amlPolicy',
  'certificateOfIncorporation',
  'memorandumArticlesOfAssociation',
  'operatingLicense',
  'proofOfAddress',
  'proofOfBusinessActivity',
  'registerOfDirectors',
  'shareholderCertificate',
  'shareholderStructureChart',
  'shareholderRegister',
]
